import { SimpleFormSelect, SimpleFormSelectOption } from "../form/SimpleFormSelect";
import { SimpleFormCheck } from "../form/SimpleFormCheck";
import SimpleFormTagsInput from "../form/SimpleFormTagsInput";
import { SimpleFormControl } from "../form/SimpleFormControl";
import { useIntl } from "react-intl";
import { SimpleFormTextarea } from "../form/SimpleFormTextarea";
import { IconButton } from "..";
import { useField } from "formik";
import { useEffect } from "react";
import { ContentType, Order, OrderType } from "src/app/types/orders/order";

export interface IUpsertDraftOrderBusinessFormBody {
    writingTypeList?: Array<SimpleFormSelectOption>;
    moneySiteList?: Array<SimpleFormSelectOption>;
    platformList?: Array<SimpleFormSelectOption>;
    thematicList?: Array<SimpleFormSelectOption>;
    fieldArrayName?: string;
    formData?: Order;
    indexOfTheForm?: number;
    handleDataForm?: (index: number | null, action: "DELETE" | "ADD") => void;
}

const UpsertDraftOrderBusinessFormBody = (props: IUpsertDraftOrderBusinessFormBody) => {
    const {
        writingTypeList = [],
        indexOfTheForm = 0,
        moneySiteList = [],
        platformList = [],
        formData,
        fieldArrayName = "",
        handleDataForm = () => {},
    } = props;
    const { formatMessage } = useIntl();
    const [moneySiteIdField] = useField(`${fieldArrayName}moneySiteId`);
    const [, , thematicIdHelper] = useField(`${fieldArrayName}thematicId`);
    const [contentTypeField, , contentTypeHelper] = useField(`${fieldArrayName}contentType`);

    const [links0] = useField(`${fieldArrayName}links.0`);
    const [writerNeededField] = useField(`${fieldArrayName}writerNeeded`);
    const [, , orderTypehelper] = useField(`${fieldArrayName}orderType`);
    const [, , wordCountHelper] = useField(`${fieldArrayName}wordCount`);
    const [orderType, , links1helpers] = useField(`${fieldArrayName}links.1`);

    useEffect(() => {
        if (links0.value?.anchor == "") {
            links1helpers.setValue(undefined);
        }
    }, [links0.value?.anchor]);

    useEffect(() => {
        if (links0.value?.url == "") {
            links1helpers.setValue(undefined);
        }
    }, [links0.value?.url]);

    useEffect(() => {
        if (!writerNeededField.value) {
            wordCountHelper.setValue(0);
        }
    }, [writerNeededField.value]);

    useEffect(() => {
        if (moneySiteIdField.value) {
            const currentMoneySite = moneySiteList?.find(
                (el) => el.value == moneySiteIdField.value
            );
            thematicIdHelper.setValue(currentMoneySite?.thematicId);
        }
    }, [moneySiteIdField.value]);

    useEffect(() => {
        if (contentTypeField.value != ContentType.BLOG)
            contentTypeHelper.setValue(ContentType.BLOG);
        if (orderType.value !== OrderType.SELL) {
            orderTypehelper.setValue(OrderType.SELL);
        }
    }, []);

    return (
        <div className="UpsertDraftOrderBusinessFormBodyWrapper">
            <div className="UpsertDraftOrderBusinessFormBodyGrid">
                <div>
                    <SimpleFormSelect
                        name={`${fieldArrayName}moneySiteId`}
                        values={moneySiteList}
                        placeholder={formatMessage({ id: "common.field.moneySite" })}
                    />
                    <SimpleFormSelect
                        name={`${fieldArrayName}platformId`}
                        values={platformList}
                        placeholder={formatMessage({ id: "common.field.platform" })}
                    />
                </div>
                <div>
                    <SimpleFormControl
                        name={`${fieldArrayName}wordCount`}
                        placeholder={formatMessage({ id: "common.field.wordsCount" })}
                        type="number"
                        disabled={!writerNeededField.value}
                        min="300"
                        step={1}
                    />

                    <SimpleFormControl
                        name={`${fieldArrayName}orderPrice`}
                        placeholder={formatMessage({ id: "common.field.orderPrice" })}
                        type="number"
                        max="300"
                        step={0.01}
                    />
                </div>
                <div>
                    <SimpleFormSelect
                        name={`${fieldArrayName}writingType`}
                        values={writingTypeList}
                        placeholder={formatMessage({ id: "common.field.writingType" })}
                    />
                    <SimpleFormTagsInput
                        name={`${fieldArrayName}keywords`}
                        tagPlaceholder={formatMessage({
                            id: "common.field.placeholder.addKeyword",
                        })}
                    />
                </div>
                <div>
                    <SimpleFormCheck
                        name={`${fieldArrayName}writerNeeded`}
                        label={formatMessage({ id: "common.field.writerNeeded" })}
                    />
                    <SimpleFormCheck
                        name={`${fieldArrayName}opti`}
                        label={formatMessage({ id: "common.field.opti" })}
                    />
                    <SimpleFormCheck
                        name={`${fieldArrayName}approveNeeded`}
                        label={formatMessage({ id: "common.field.approveNeeded" })}
                    />
                    <SimpleFormCheck
                        name={`${fieldArrayName}priority`}
                        label={formatMessage({ id: "common.field.priority" })}
                    />
                </div>
                <div>
                    <SimpleFormControl
                        placeholder={formatMessage({ id: "common.field.title" })}
                        name={`${fieldArrayName}title`}
                    />

                    <div>
                        <div className="sideForm">
                            <div className="flex-grow-1">
                                <SimpleFormControl
                                    name={`${fieldArrayName}links.0.url`}
                                    placeholder={formatMessage({ id: "common.field.url" })}
                                />
                            </div>
                            <SimpleFormControl
                                disabled={!links0.value}
                                name={`${fieldArrayName}links.0.anchor`}
                                placeholder={formatMessage({ id: "common.field.anchor" })}
                            />
                        </div>
                        {links0.value?.url != "" &&
                            links0.value?.anchor != "" &&
                            links0.value?.url != undefined &&
                            links0.value?.anchor != undefined && (
                                <div className="sideForm">
                                    <div className="flex-grow-1">
                                        <SimpleFormControl
                                            name={`${fieldArrayName}links.1.url`}
                                            placeholder={formatMessage({ id: "common.field.url" })}
                                        />
                                    </div>
                                    <SimpleFormControl
                                        disabled={!links0.value}
                                        name={`${fieldArrayName}links.1.anchor`}
                                        placeholder={formatMessage({ id: "common.field.anchor" })}
                                    />
                                </div>
                            )}
                    </div>
                </div>

                <div className="commentForWrapper">
                    <SimpleFormTextarea
                        name={`${fieldArrayName}commentForWriter`}
                        className="textarea"
                        rows={1}
                        placeholder={formatMessage({ id: "common.field.commentForWriter" })}
                        type="textarea"
                    />
                    <SimpleFormTextarea
                        name={`${fieldArrayName}commentForLinker`}
                        className="textarea"
                        rows={1}
                        placeholder={formatMessage({ id: "common.field.commentForLinker" })}
                        type="textarea"
                    />
                </div>

                <div className="actionsWrapper">
                    {formData?.id && (
                        <SimpleFormCheck type="checkbox" name={`${fieldArrayName}draft`} />
                    )}
                    <span className="svg-icon svg-icon-2x svg-icon-primary">
                        <IconButton
                            onClick={() => {
                                handleDataForm(null, "ADD");
                            }}
                            width={32}
                            src="/media/icons/duotune/general/gen041.svg"
                        />
                    </span>
                    <span className="svg-icon svg-icon-2x svg-icon-success">
                        <IconButton
                            width={32}
                            onClick={() => {
                                handleDataForm(indexOfTheForm, "ADD");
                            }}
                            src="/media/icons/duotune/general/gen028.svg"
                        />
                    </span>
                    {indexOfTheForm != 0 && (
                        <span className="svg-icon svg-icon-2x svg-icon-danger">
                            <IconButton
                                width={32}
                                onClick={() => {
                                    handleDataForm(indexOfTheForm, "DELETE");
                                }}
                                src="/media/icons/duotune/general/gen027.svg"
                            />
                        </span>
                    )}
                </div>
            </div>
            <hr></hr>
        </div>
    );
};
export default UpsertDraftOrderBusinessFormBody;
